import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Button, Dialog,DialogContent,DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import {
  // getdevicelist,
  setGeneralConfiguration,
  getGeneralConfiguration,
  getTagConfiguration
} from "../../Restclient/datacollection";
import { useSelector, useDispatch } from "react-redux";
import LK_Add from "../../images/LK_Add";
import LK_Delete from "../../images/LK_Delete";
// import CustomDatePicker from "../CommonComponents/CustomDatePicker";
// import dayjs from "dayjs";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import CustomToast from "../CommonComponents/CustomToast";
import LK_Loading from "../../images/LK_Loading.gif";
import { updategeneralConfiguration } from "../../store/mainpage_data";
import LK_ArrowDown from '../../images/LK_ArrowDown';
import {Tree} from "antd";
import CustomSelectedOptions from "../CommonComponents/CustomSelectedOptions";
import CustomLabel from "../CommonComponents/CustomLabel";
import LK_ArrowRight from '../../images/LK_ArrowRight';


export default function General() {
  const { theme } = useContext(ThemeContext);
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const energyUnitType = ["Wh", "Vah"];
  const costUnit = ["₹", "€", "$"];
  // const energyUnit = ['kWh','kW','kVah','kVa','MWh','MW','GWh','GW'];
  const energyUnit = [
    ["Wh", "kWh", "MWh", "GWh"],
    ["Vah", "kVah", "MVah", "GVah"],
  ];
  const [energyValues, setEnergyValues] = React.useState({
    baseline: "",
    target: "",
    energyPerUnitCost: "",
    maximumLimit: "",
  });
  const [costValues, setCostValues] = React.useState({
    baseline: "",
    target: "",
  });
  const [unit, setUnit] = React.useState({
    costUnit: costUnit[0],
    energyUnit: energyUnit[0][0],
    energyUnitType: energyUnitType[0],
  });
  const [shiftDetails, setShiftDetails] = React.useState([["", ""]]);
  const [TOD, setTOD] = React.useState([["", [""], ""]]);
  const [decimalPoints, setDecimalPoints] = React.useState(2);
  const [co2EmissionFactor, setCo2EmissionFactor] = React.useState(0);
  const [alertSoundSettings, setAlertSoundSettings] = React.useState({
    HighestPriority: false,
    HighPriority: false,
    MediumPriority: false,
    LowPriority: false,
  });
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const [loading, setLoading] = useState(1);
  const [maxlimitmsg, setMaxlimitmsg] = useState([0, ""]);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [OGData, setOGData] = useState({});
  const [powerSupply, setpowerSupply] = React.useState({
      EB: "",
      DG: "",
      RE: "",
    });
    const [powerTagSupply, setpowerTagSupply] = React.useState({
      EBTag: {Device:'', Tag:'', Aggregation:''},
      DGTag: {Device:'', Tag:'', Aggregation:''},
      RETag: {Device:'', Tag:'', Aggregation:''},
    });

      const [aggregationOption, setAggregationOption] = useState([]);
        const [disabledAggOptions, setDisabledAggOptions] = useState([]);
        const [selectedTagDetails, setSelectedTagDetails] = useState(null);
        const [selectedRightItems, setSelectedRightItems] = useState([]);
            const [rightList, setRightList] = useState([]);
              const [table_rows, setTable_rows] = useState([]);
                const [currentSelectedTag, setCurrentSelectedTag] = useState({Device:'', Tag:'', Aggregation:''});
              
        
    
      const [selectedTag, setSelectedTag] = useState([]);
      const [selectedDevice, setSelectedDevice] = useState([]);
        const [openTagDialog, setOpenTagDialog] = useState([false, ""]);
        const [tagConfiguration, setTagConfiguration] = React.useState([]);
        // const [devicelist, setDevicelist] = useState([],[]);
      
      
    
  const dispatch = useDispatch();

  useEffect(() => {
    // getdevicelist(getdevicelistcallback);
    getGeneralConfiguration(getgeheralconfigcallback);
    getTagConfiguration(getTagCallback);
  }, []);

  useEffect(() => {
    // getdevicelist(getdevicelistcallback);
    getGeneralConfiguration(getgeheralconfigcallback);
    getTagConfiguration(getTagCallback);
  }, [projectname]);

  const getTagCallback = (res) => {
    setTagConfiguration(res);
  };

  function getgeheralconfigcallback(res) {
    if (res.request.status === 200) {
      setEnergyValues({
        baseline: res.data.configinfo.EnergyBaseline,
        target: res.data.configinfo.EnergyYearlyTarget,
        energyPerUnitCost: res.data.configinfo.EnergyPerUnitCost,
        maximumLimit: res.data.configinfo.EnergyMaximumLimit,
      });
      setCostValues({
        baseline: res.data.configinfo.CostBaseline,
        target: res.data.configinfo.CostTarget,
      });
      setCo2EmissionFactor(res.data.configinfo.co2EmissionFactor);
      setUnit({
        costUnit: res.data.configinfo.CostUnit,
        energyUnit: res.data.configinfo.EnergyUnit,
        energyUnitType: res.data.configinfo.EnergyTypeUnit,
      });
      setShiftDetails(res.data.configinfo.ShiftwiseInformation);
      setTOD(res.data.configinfo.TOD);
      setDecimalPoints(res.data.configinfo.DecimalPrecision);
      setAlertSoundSettings({
        HighestPriority: res.data.configinfo.AlertSoundSettings.HighestPriority,
        HighPriority: res.data.configinfo.AlertSoundSettings.HighPriority,
        MediumPriority: res.data.configinfo.AlertSoundSettings.MediumPriority,
        LowPriority: res.data.configinfo.AlertSoundSettings.LowPriority,
      });
      setLoading(0);
      setpowerSupply({
        EB: res.data.configinfo.EB,
        DG: res.data.configinfo.DG,
        RE: res.data.configinfo.RE,
      });
      setpowerTagSupply({
        EBTag: res.data.configinfo.EBTag,
        DGTag: res.data.configinfo.DGTag,
        RETag: res.data.configinfo.RETag,
      });
      setOGData(res.data.configinfo);
    } else {
      //unable to fetch data
      // setEnergyValues({
      //   baseline: "",
      //   target: "",
      //   energyPerUnitCost: "",
      //   maximumLimit: "",
      // });
      // setCostValues({ baseline: "", target: "" });
      // setUnit({
      //   costUnit: costUnit[0],
      //   energyUnit: energyUnit[0][0],
      //   energyUnitType: energyUnitType[0],
      // });
      // setShiftDetails([["", ""]]);
      // setTOD([["", [""], ""]]);
      // setDecimalPoints(2);
      // setAlertSoundSettings({
      //   HighestPriority: false,
      //   HighPriority: false,
      //   MediumPriority: false,
      //   LowPriority: false,
      // });
      // setpowerSupply({
      //   EB: "",
      //   DG: "",
      //   RE: "",
      // });
      // setpowerTagSupply({
      //   EBTag: "",
      //   DGTag: "",
      //   RETag: "",
      // });
      setLoading(0);
      setOGData({
        EnergyBaseline: energyValues.baseline,
        EnergyYearlyTarget: energyValues.target,
        EnergyPerUnitCost: energyValues.energyPerUnitCost,
        EnergyMaximumLimit: energyValues.maximumLimit,
        CostTarget: costValues.target,
        CostBaseline: costValues.baseline,
        ShiftwiseInformation: shiftDetails,
        DecimalPrecision: decimalPoints,
        CostUnit: unit.costUnit,
        EnergyUnit: unit.energyUnit,
        EnergyTypeUnit: unit.energyUnitType,
        AlertSoundSettings: alertSoundSettings,
        TOD: TOD,
        EB: powerSupply.EB,
        DG: powerSupply.DG,
        RE: powerSupply.RE,
        EBTag: powerTagSupply.EBTag,
        DGTag: powerTagSupply.DGTag,
        RETag: powerTagSupply.RETag
      });
    }
  }

  // function getdevicelistcallback(res) {
  //   let data = [];
  //   res.map((_val, index) => {
  //     data = [...data, res[index].deviceName];
  //   });
  //   setDevicelist(data)
  // }

  const handleCloseAddForm = () => {
    setOpenCancelDialog(true);
    //setRequired(0);
    // setAssetInfo({organizationId:"",projectId:"",id:"",data:{assetName:"",serialNo:"",description:"",/*commissionDate:"",decommissionDate:"",*/associatedDevices:[]}})
  };

  function handleConfirmCancel() {
    setSaveStatus(0);
    setRequired(0);

    setEnergyValues({
      baseline: OGData.EnergyBaseline,
      target: OGData.EnergyYearlyTarget,
      energyPerUnitCost: OGData.EnergyPerUnitCost,
      maximumLimit: OGData.EnergyMaximumLimit,
    });
    setCostValues({ baseline: OGData.CostBaseline, target: OGData.CostTarget });
    setUnit({
      costUnit: OGData.CostUnit,
      energyUnit: OGData.EnergyUnit,
      energyUnitType: OGData.EnergyTypeUnit,
    });
    setShiftDetails(OGData.ShiftwiseInformation);
    setTOD(OGData.TOD);
    setDecimalPoints(OGData.DecimalPrecision);
    setAlertSoundSettings(OGData.AlertSoundSettings);
    setOpenCancelDialog(false);
  }

  //   function handleDeviceIDtoName(deviceName) {
  //   let id = [];
  //   for (let j = 0; j < deviceName.length; j++) {
  //     for (let i = 0; i < devicelist[0].length; i++) {
  //       if (devicelist[0][i] === deviceName[j]) {
  //         id = [...id, devicelist[1][i]];
  //       }
  //     }
  //   }
  //   return id;
  // }

  function handleRemoveOption(selectedValue,id) {
    if(id==="EB"){
      setpowerSupply({...powerSupply, EB: ""});
      setpowerTagSupply({...powerTagSupply, EBTag: {Device:'', Tag:'', Aggregation:''}});
    } else if(id==="DG"){
      setpowerSupply({...powerSupply, DG: ""});
      setpowerTagSupply({...powerTagSupply, DGTag: {Device:'', Tag:'', Aggregation:''}});
    } else if(id==="RE"){
      setpowerSupply({...powerSupply, RE: ""});
      setpowerTagSupply({...powerTagSupply, RETag: {Device:'', Tag:'', Aggregation:''}});
    }

    // const temp = selectedDevicesList.filter(
    //   (_value, index) => index !== parseInt(selectedValue, 10),
    // );
    // setSelectedDevicesList(temp);
  }

  
    const moveLeft = () => {
    if (selectedRightItems.length > 0) {
      // Remove selected items from rightList
      const updatedRightList = selectedTag.filter(
        (item) => !selectedRightItems.includes(item),
      );
      // setRightList(updatedRightList);

      

      setSelectedTag(updatedRightList);

      // Clear selected items
      setSelectedRightItems([]);
    } else {
    }
  };

  const moveRight = () => {
    if (
      currentSelectedTag.Tag!== '' &&
      currentSelectedTag.Aggregation!== '' &&
      aggregationOption.length > 0 &&
      selectedTagDetails
    ) {

      if(openTagDialog[1] === "Guzzlers"){
        // Create entries - filter out duplicates
          const ifDuplicate =  selectedTag.filter((val) => val.Aggregation === currentSelectedTag.Aggregation && val.Tag === selectedTagDetails.key && val.Device === currentSelectedTag.Device);    

            if(ifDuplicate.length === 0){
              setSelectedTag([...selectedTag,{...currentSelectedTag}]);
            }
        }else{
          // For other tags, only one selection allowed, so replace existing entry
          setSelectedTag([{...currentSelectedTag}]);
        }

      // Clear selections
      setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
      setSelectedTagDetails(null);
      setAggregationOption([]);
      setDisabledAggOptions([]);
    } 
  };

    function handleAggregationOption(selectedValue, isChecked) {
    if (isChecked) {
      // Add the value if checked (isChecked = true means checkbox is now checked)
      setAggregationOption([...aggregationOption, selectedValue]);
      setCurrentSelectedTag({...currentSelectedTag, Aggregation:selectedValue}); 
    } else {
      // Remove the value if unchecked (isChecked = false means checkbox is now unchecked)
      setAggregationOption(
        aggregationOption.filter((item) => item !== selectedValue),
      );
      setCurrentSelectedTag({...currentSelectedTag, Aggregation:''});
    }
  }

  function handleCloseTagDialog() {
    setSelectedTag([]);
    setSelectedDevice([]);
    setOpenTagDialog([false, ""]);
    setRightList([...table_rows]);
    setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
    setSelectedTagDetails(null);
    setAggregationOption([]);
    setSelectedRightItems([]);
    setDisabledAggOptions([]);
    //handleClose(event, "closeButton");
  }

  
  function handleTagConfirmDialog() {
    if(openTagDialog[1] === "EB"){
      powerTagSupply.EBTag = selectedTag.length > 0 ? {Device:selectedTag[0].Device, Tag:selectedTag[0].Tag, Aggregation:selectedTag[0].Aggregation} : {Device:'', Tag:'', Aggregation:''};
      setpowerTagSupply(powerTagSupply);
    }
    else if(openTagDialog[1] === "DG"){
      powerTagSupply.DGTag = selectedTag.length > 0 ? {Device:selectedTag[0].Device, Tag:selectedTag[0].Tag, Aggregation:selectedTag[0].Aggregation} : {Device:'', Tag:'', Aggregation:''};
      setpowerTagSupply(powerTagSupply);
    }
    else if(openTagDialog[1] === "RE"){
      powerTagSupply.RETag = selectedTag.length > 0 ? {Device:selectedTag[0].Device, Tag:selectedTag[0].Tag, Aggregation:selectedTag[0].Aggregation} : {Device:'', Tag:'', Aggregation:''};
      setpowerTagSupply(powerTagSupply);
    }
    setOpenTagDialog([false, ""]);
    setSelectedTag([]);
    setSelectedDevice([]);
    setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
    setSelectedRightItems([]);
    //saveTaglist();
  }

  function handlePowerSupplyEB(selected) {
    powerSupply.EB = selected;
    setpowerSupply(powerSupply);
  }
  function handlePowerSupplyDG(selected) {
    powerSupply.DG = selected;
    setpowerSupply(powerSupply);
  }
  function handlePowerSupplyRE(selected) {
    powerSupply.RE = selected;
    setpowerSupply(powerSupply);
  }

  const processTreeData = (nodes, mode, pkey) => {
    return nodes.map((node) => {
      const processedNode = {
        ...node,
        title: renderTitle(node.title || node.key, node.type, node.key, node, mode, pkey),
        children: node.children ? processTreeData(node.children, mode, node.key) : undefined,
      };
      return processedNode;
    });
  };
  
  
  // Helper to create node titles with right-aligned icons
    const renderTitle = (title, type, key, node, mode, pkey) => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
          }}
        >
          {/* Left side: title with icon */}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {type === "tag" ? (
              <CustomCheckbox
                checked={currentSelectedTag.Tag===key}
                onChange={(checked) => {
                  if(mode === "single"){
                    if (checked) {
                      // setSelectedTag([key]);
                      // setSelectedDevice([pkey]);
                      setCurrentSelectedTag({Tag: key, Device: pkey, Aggregation: ''});
                      setSelectedTagDetails({
                          key: key,
                          title: title,
                          fullPath: node.fullPath || title,
                          parentPath: node.parentPath || "",
                          storage: node.storage,
                        });
                      // setCurrStorage(node.storage);
                    } else {
                      // setSelectedTag([]);
                      // setSelectedDevice([]);
                      setCurrentSelectedTag({Tag: '', Device: '', Aggregation: ''});
                      setSelectedTagDetails(null);
                      // setCurrStorage(null);
                    }
                  }
                  else{
                    if (checked) {
                      // setSelectedTag([...selectedTag, key]);
                      // setSelectedDevice([...selectedDevice, pkey]);
                      setCurrentSelectedTag({Tag: key, Device: pkey, Aggregation: ''});
                      setSelectedTagDetails({
                          key: key,
                          title: title,
                          fullPath: node.fullPath || title,
                          parentPath: node.parentPath || "",
                          storage: node.storage,
                        });
                      // setCurrStorage(node.storage);
                    } else {
                      // setSelectedTag(selectedTag.filter((tag) => tag !== key));
                      // setSelectedDevice(selectedDevice.filter((device) => device !== pkey));
                      setCurrentSelectedTag({Tag: '', Device: '', Aggregation: ''});
                                        setSelectedTagDetails(null);
                      // setCurrStorage(null);
                    }
                  }
                }}
              />
            ) : (
              <></>
            )}
            <span
              style={{ color: theme === "dark" ? "#FFFFFF" : "#5B5B5B" }}
            >
              {title}
            </span>
          </div>
        </div>
      );
    };
  

  const handleSaveAddForm = () => {
    // let req = 0;
    // TOD.map((val)=>{
    //     if (val[0] === "" && val[2] === ""){
    //         req = 1;
    //     }
    //     else {
    //         val[1].map((value)=>{
    //             if (value === ""){
    //                 req = 1;
    //             }
    //         })
    //     }
    // })
    // shiftDetails.map((val)=>{
    //     if (val[0] === "" && val[1] === ""){
    //         req = 1;
    //     }
    // })
    // && req !==1
    let flag = 0;
    if((powerSupply.EB !== "" || powerSupply.DG !== "" || powerSupply.RE !== "") && (powerTagSupply.EB !== "" || powerTagSupply.DG !== "" || powerTagSupply.RE !== "")){
        flag = 1;
    }else{
      flag = 0;
    }
    if (
      energyValues.target !== "" &&
      energyValues.energyPerUnitCost !== "" &&
      energyValues.maximumLimit !== "" &&
      costValues.target !== "" &&
      unit.costUnit !== "" &&
      unit.energyUnit !== "" &&
      flag === 1
    ) {
      const info = {
        organizationId: userdetails.Organizationid,
        projectId: projectname,
        energyBaseline: energyValues.baseline,
        energyTarget: energyValues.target,
        energyPerUnitCost: energyValues.energyPerUnitCost,
        energyMaximumLimit: energyValues.maximumLimit,
        co2EmissionFactor: co2EmissionFactor,
        costBaseline: costValues.baseline,
        costTarget: costValues.target,
        costUnit: unit.costUnit,
        energyUnit: unit.energyUnit,
        energyUnitType: unit.energyUnitType,
        decimalPoints: decimalPoints,
        TOD: TOD,
        shiftDetails: shiftDetails,
        alertSoundSettings: alertSoundSettings,
        EB: powerSupply.EB,
        DG: powerSupply.DG,
        RE: powerSupply.RE,
        EBTag: powerTagSupply.EBTag,
        DGTag: powerTagSupply.DGTag,
        RETag: powerTagSupply.RETag,
      };
      setGeneralConfiguration(info, saveCallback);
      setRequired(0);
      setLoading(1);
    } else {
      setRequired(1);
    }
  };

  function saveCallback(res) {
    if (res.request.status === 200) {
      // setEnergyValues({'baseline':res.data.configinfo.EnergyBaseline,'target': res.data.configinfo.EnergyYearlyTarget})
      // setCostValues({'baseline': res.data.configinfo.CostBaseline,'target': res.data.configinfo.CostTarget})
      // setUnit({'costUnit': res.data.configinfo.CostUnit,'energyUnit': res.data.configinfo.EnergyUnit,'energyUnitType': res.data.configinfo.EnergyTypeUnit})
      // setShiftDetails(res.data.configinfo.ShiftwiseInformation)
      // setTOD(res.data.configinfo.TOD)
      // setDecimalPoints(res.data.configinfo.DecimalPrecision)
      // setAlertSoundSettings(res.data.configinfo.AlertSoundSettings)
      const data = {
        energyBaseline: energyValues.baseline,
        energyTarget: energyValues.target,
        energyPerUnitCost: energyValues.energyPerUnitCost,
        energyMaxLimit: energyValues.maximumLimit,
        //co2EmissionFactor : co2EmissionFactor,
        costBaseline: costValues.baseline,
        costTarget: costValues.target,
        costUnit: unit.costUnit,
        energyUnit: unit.energyUnit,
        energyUnitType: unit.energyUnitType,
        decimalPoints: decimalPoints,
        alertSoundSettings: alertSoundSettings,
        EB: powerSupply.EB,
        DG: powerSupply.DG,
        RE: powerSupply.RE,
        EBTag: powerTagSupply.EBTag,
        DGTag: powerTagSupply.DGTag,
        RETag: powerTagSupply.RETag,
      };
      dispatch(updategeneralConfiguration(data));
      setOGData({
        EnergyBaseline: energyValues.baseline,
        EnergyYearlyTarget: energyValues.target,
        EnergyPerUnitCost: energyValues.energyPerUnitCost,
        EnergyMaximumLimit: energyValues.maximumLimit,
        CostTarget: costValues.target,
        CostBaseline: costValues.baseline,
        ShiftwiseInformation: shiftDetails,
        DecimalPrecision: decimalPoints,
        CostUnit: unit.costUnit,
        EnergyUnit: unit.energyUnit,
        EnergyTypeUnit: unit.energyUnitType,
        AlertSoundSettings: alertSoundSettings,
        TOD: TOD,
        EB: powerSupply.EB,
        DG: powerSupply.DG,
        RE: powerSupply.RE,
        EBTag: powerTagSupply.EBTag,
        DGTag: powerTagSupply.DGTag,
        RETag: powerTagSupply.RETag,

      });
      setSaveStatus(1);
      setLoading(0);
    } else {
      //unable to fetch data
      setSaveStatus(2);
      setLoading(0);
    }
  }

  function handleEnergyTarget(selected) {
    energyValues.target = selected;
    setEnergyValues(energyValues);
  }

  function handleEnergyPerUnitCost(selected) {
    energyValues.energyPerUnitCost = selected;
    setEnergyValues(energyValues);
  }

  function handleco2EmissionFactor(selected) {
    // co2EmissionFactor=selected
    setCo2EmissionFactor(selected);
  }

  function handleEnergyMaximumLimit(selected) {
    energyValues.maximumLimit = selected;
    setEnergyValues(energyValues);
  }

  function handleEnergyBaseline(selected) {
    energyValues.baseline = selected;
    setEnergyValues(energyValues);
  }

  function handleEnergyUnit(selected) {
    unit.energyUnit = selected;
    setUnit(unit);
  }

  function handleEnergyUnitType(selected) {
    // unit.energyUnitType=selected
    setUnit({ ...unit, energyUnitType: selected });
  }

  function handleCostTarget(selected) {
    costValues.target = selected;
    setCostValues(costValues);
  }

  function handleCostBaseline(selected) {
    costValues.baseline = selected;
    setCostValues(costValues);
  }

  function handleCostUnit(selected) {
    unit.costUnit = selected;
    setUnit(unit);
  }

  function handleDecimalPoints(selected) {
    // decimalPoints=selected
    setDecimalPoints(selected);
  }

  function handleShiftName(selected, event) {
    shiftDetails[event.currentTarget.id][0] = selected;
    setShiftDetails(shiftDetails);
  }

  function handleShiftTime(selected, event) {
    shiftDetails[event.currentTarget.id][1] = selected;
    setShiftDetails(shiftDetails);
  }

  function handleShiftDelete(event) {
    if (shiftDetails.length > 1) {
      const temp = shiftDetails.filter(
        (_value, index) => index !== parseInt(event.currentTarget.id, 10),
      );
      setShiftDetails(temp);
    } else {
      setShiftDetails([["", ""]]);
    }
  }

  // useEffect(()=>{
  // },[shiftDetails])
  useEffect(() => {
        if (currentSelectedTag.Tag !== '' && selectedTagDetails !== null) {
    
          // Check if selectedTagDetails has storage property
          
          if (selectedTagDetails.storage && Array.isArray(selectedTagDetails.storage)) 
          {
  
            let data =[];
  
            selectedTagDetails.storage.forEach((obj) => {
              const value = Object.values(obj)[0];
              value.map((val) => {
                data.push(val);
              });
            });
  
            const aggreationFunctions = [...new Set(data)];
    
            if (aggreationFunctions !== null && Array.isArray(aggreationFunctions)) {
              // value should contain the available aggregation options
              // Disable all options that are NOT in the value array
              const allOptions = [
                "SUM",
                "DIFF",
                "AVG",
                "MIN",
                "MAX",
                "SVAL",
                "EVAL",
              ];
              const disabledOptions = allOptions.filter(
                (option) => !aggreationFunctions.includes(option),
              );
  
              setDisabledAggOptions(disabledOptions);
            } else {
              // If no storage found, disable all options
              setDisabledAggOptions([
                "SUM",
                "DIFF",
                "AVG",
                "MIN",
                "MAX",
                "SVAL",
                "EVAL",
              ]);
            }
          } else {
            // If no storage property, disable all options
            setDisabledAggOptions([
              "SUM",
              "DIFF",
              "AVG",
              "MIN",
              "MAX",
              "SVAL",
              "EVAL",
            ]);
          }
        } else {
          // Clear disabled options when no tag is selected ///????when  no tag selected all should be disabled right?
          // setDisabledAggOptions([]);
          setDisabledAggOptions(["SUM", "DIFF", "AVG", "MIN", "MAX", "SVAL", "EVAL"]);
        }
      }, [currentSelectedTag, selectedTagDetails]); 

  function handleShiftAdd() {
    if (shiftDetails.length < 4) {
      setShiftDetails([...shiftDetails, ["", ""]]);
    } else {
      setMaxlimitmsg([1, "Max 4 Shifts can be added"]);
    }
  }

  function handleTODZone(selected, event) {
    TOD[event.currentTarget.id][0] = selected;
    setTOD(TOD);
  }

  function handleTODUnitRate(selected, event) {
    TOD[event.currentTarget.id][2] = selected;
    setTOD(TOD);
  }

  function handleTODTime(selected, event) {
    const dotindex = event.currentTarget.id.indexOf(".");
    const index = event.currentTarget.id.slice(0, dotindex);
    const id = event.currentTarget.id.slice(dotindex + 1);
    TOD[index][1][id] = selected;
    setTOD(TOD);
  }

  function handleTODAdd() {
    if (TOD.length < 8) {
      setTOD([...TOD, ["", [""], ""]]);
    } else {
      setMaxlimitmsg([1, "Max 8 TOD can be added"]);
    }
  }

  function handleTODTimeAdd(event) {
    const temp = [...TOD[event.currentTarget.id][1], ""];
    TOD[event.currentTarget.id][1] = [...temp];
    setTOD([...TOD]);
  }

  function handleTODDelete(event) {
    if (TOD.length > 1) {
      const temp = TOD.filter(
        (_value, index) => index !== parseInt(event.currentTarget.id, 10),
      );
      setTOD(temp);
    } else {
      setTOD([["", [""], ""]]);
    }
  }

  function handleTODTimeDelete(event) {
    const dotindex = event.currentTarget.id.indexOf(".");
    const index = event.currentTarget.id.slice(0, dotindex);
    const id = parseInt(event.currentTarget.id.slice(dotindex + 1), 10);
    if (TOD[index][1].length > 1) {
      const temp = TOD[index][1].filter((_value, index) => index !== id);
      TOD[index][1] = [...temp];
      setTOD([...TOD]);
    } else {
      TOD[index][1] = [""];
      setTOD([...TOD]);
    }
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleIDtoName(tags) {
    let data =[]
    tags.map((dval) => {
    tagConfiguration.map((val) => {
        if (val.key === dval.Device) {
          // tagID.map((tval) => {
            let tagmatch = val.children.filter((tag) => tag.key === dval.Tag); 
            // if(val.tags){
            // }
            if(tagmatch.length > 0){  
              data.push(val.title +"."+ tagmatch[0].title);
            }
          // })
        }
      });
    });
    return data;
  }

    return (
        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box" }}>
            <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:"8px"}} >
                    <Box sx={{flexGrow:1}}></Box>
                    {saveStatus!==0?
                        <>
                            <CustomToast openToast={saveStatus!==0} type={ saveStatus===1?"Success":"Error"} autoHideDuration={10000} toastText={saveStatus===1?"Saved Successfully!":"Save Failed"} onClose={handleToastClose}/>
                        </>
                        :
                        <></>
                    }
                    <CustomDialogBox dialogTitle={"Required fields not filled"} dialogText={"Required fields to must be filled"} openDialog={required===1} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <CustomDialogBox dialogTitle={"Are you sure you want cancel"} dialogText={"All the changes made will be discarded."} openDialog={openCancelDialog} handleCloseDialog={()=>setOpenCancelDialog(false)} handleConfirmDialog={handleConfirmCancel} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <CustomDialogBox dialogTitle={"Addition max limit"} dialogText={maxlimitmsg[1]} openDialog={maxlimitmsg[0]===1} handleCloseDialog={()=>setMaxlimitmsg([0,""])} handleConfirmDialog={()=>setMaxlimitmsg([0,""])} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <CustomCancelButton onClick={handleCloseAddForm} buttonText={'Cancel'}></CustomCancelButton>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                    <CustomButton /*id={assetInfo.id}*/ onClick={handleSaveAddForm} buttonText={'Save'} width={'12px'} />
                </Box>
                <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"auto"}}>
                    {/* <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}> */}
                        {loading===0?   
                            <>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Unit Type<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomDropDown options={energyUnitType} onChange={handleEnergyUnitType} defaultValue={unit.energyUnitType} disabled={true} maxLength={16} width={224}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Unit <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomDropDown options={unit.energyUnitType === energyUnitType[0]? energyUnit[0] : energyUnit[1]} onChange={handleEnergyUnit} disabled={unit.energyUnitType===""?true:true} defaultValue={unit.energyUnit} maxLength={16} width={224}/> 
                                </Box> 
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Target (Yearly)<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleEnergyTarget} defaultValue={energyValues.target} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Baseline (Yearly)</Typography>
                                    <CustomTextField onChange={handleEnergyBaseline} defaultValue={energyValues.baseline} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                    {/* <CustomDatePicker onChange={handleEnergyBaseline}  views={['year']}  defaultValue={dayjs(new Date())}/>  */}
                                    {/* <CustomDatePicker name={"data-entry-date"} width={224} onChange={handleEnergyBaseline} defaultValue={dayjs(new Date())} views={["year"]}/> */}
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Maximum Limit (Yearly)<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleEnergyMaximumLimit} defaultValue={energyValues.maximumLimit} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Energy Per Unit Cost <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleEnergyPerUnitCost} defaultValue={energyValues.energyPerUnitCost} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Cost Unit <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    {/* <CustomTextField onChange={handleCostUnit} defaultValue={unit.costUnit} maxLength={16} width={224}/>  */}
                                    <CustomDropDown options={costUnit} onChange={handleCostUnit} defaultValue={unit.costUnit} maxLength={16} width={224}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Cost Target <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleCostTarget} defaultValue={costValues.target} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Cost Baseline </Typography>
                                    <CustomTextField onChange={handleCostBaseline} defaultValue={costValues.baseline} maxLength={16} width={224} permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                    {/* <CustomDatePicker name={"data-entry-date"} width={224} onChange={handleCostBaseline} defaultValue={dayjs(new Date())} views={["year"]}/> */}
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Decimal Points<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleDecimalPoints} defaultValue={decimalPoints} maxLength={16} width={224} permittedCharacters={"^([0-9]*)?$"} errorText={"Only numeric characters are allowed"}/> 
                                    {/* <CustomNumberField onChange={handleDecimalPoints} defaultValue={decimalPoints} width={224}/> */}
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Alert Sound Settings{/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                    {/* <CustomTextField onChange={handleDecimalPoints} defaultValue={decimalPoints} maxLength={16} width={224}/>  */}
                                    <Box sx={{display:'flex' , flexDirection:'column' ,padding:'0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomCheckbox id={"Highest Priority"} onChange={selected => setAlertSoundSettings({...alertSoundSettings, HighestPriority: selected})} checked={alertSoundSettings.HighestPriority} />
                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)" }}>Enable Audio for Highest Priority</Typography>
                                        </Box>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomCheckbox id={"High Priority"} onChange={selected => setAlertSoundSettings({...alertSoundSettings, HighPriority : selected})} checked={alertSoundSettings.HighPriority} />
                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)" }}>Enable Audio for High Priority</Typography>
                                        </Box>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomCheckbox id={"Medium Priority"} onChange={selected => setAlertSoundSettings({...alertSoundSettings, MediumPriority: selected})} checked={alertSoundSettings.MediumPriority} />    
                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)" }}>Enable Audio for Medium Priority</Typography>
                                        </Box>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomCheckbox id={"Low Priority"} onChange={selected => setAlertSoundSettings({...alertSoundSettings, LowPriority: selected})} checked={alertSoundSettings.LowPriority} />
                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)" }}>Enable Audio for Low Priority</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Power supply<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                        <>
                                            <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px", minWidth:"44px"}}>EB</Typography>
                                                {/* <CustomDropDown options={devicelist[1]} id={'EB'} onChange={handlePowerSupplyEB} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.EB!==""?powerSupply.EB:devicelist[1][0]}></CustomDropDown>
                                                <CustomDropDown options={devicelist[1]} id={'EB'} onChange={handlePowerSupplyEB} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.EB!==""?powerSupply.EB:devicelist[1][0]}></CustomDropDown> */}
                                                <CustomButton onClick={()=>{setOpenTagDialog([true, "EB"]); setSelectedTag(powerTagSupply.EBTag.Tag!=='' && powerTagSupply.EBTag.Aggregation!==''?[{Device:powerTagSupply.EBTag.Device,Tag:powerTagSupply.EBTag.Tag,Aggregation:powerTagSupply.EBTag.Aggregation}]:[])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                                {(powerSupply.EB!=="")?<Box sx={{width:"calc(100% - 206px)"}}><CustomSelectedOptions id={"EB"} selectedOptions={powerSupply.EB!==""?handleIDtoName([powerTagSupply.EBTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions></Box>:<></>}
                                                {/* <AssetTagsRetrievalModified 
                                            assetdata={assetdata} 
                                            setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                            setSelectedTag={setSelectedTag} 
                                            setSelectedAsset={setSelectedAsset} 
                                        /> */}
                                            </Box> 
                                            <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px"}}>DG</Typography>
                                                {/* <CustomDropDown options={devicelist[1]} id={'DG'} onChange={handlePowerSupplyDG} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.DG!==""?powerSupply.DG:devicelist[1][0]}></CustomDropDown>
                                                <CustomDropDown options={devicelist[1]} id={'DG'} onChange={handlePowerSupplyDG} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.DG!==""?powerSupply.DG:devicelist[1][0]}></CustomDropDown> */}
                                                <CustomButton onClick={()=>{setOpenTagDialog([true, "DG"]); setSelectedTag(powerTagSupply.DGTag.Tag!=='' && powerTagSupply.DGTag.Aggregation!==''?[{Device:powerTagSupply.DGTag.Device,Tag:powerTagSupply.DGTag.Tag,Aggregation:powerTagSupply.DGTag.Aggregation}]:[])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                                  {(powerSupply.DG!=="")?<Box sx={{width:"calc(100% - 206px)"}}><CustomSelectedOptions id={"DG"} selectedOptions={powerSupply.DG!==""?handleIDtoName([powerTagSupply.DGTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions></Box>:<></>}
                                            </Box>
                                            <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px"}}>RE</Typography>
                                                {/* <CustomDropDown options={devicelist[1]} id={'RE'} onChange={handlePowerSupplyRE} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.RE!==""?powerSupply.RE:devicelist[1][0]}></CustomDropDown>
                                                <CustomDropDown options={devicelist[1]} id={'RE'} onChange={handlePowerSupplyRE} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.RE!==""?powerSupply.RE:devicelist[1][0]}></CustomDropDown> */}
                                                <CustomButton onClick={()=>{setOpenTagDialog([true, "RE"]);setSelectedTag(powerTagSupply.RETag.Tag!=='' && powerTagSupply.RETag.Aggregation!==''?[{Device:powerTagSupply.RETag.Device,Tag:powerTagSupply.RETag.Tag,Aggregation:powerTagSupply.RETag.Aggregation}]:[])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                                {(powerSupply.RE!=="")?<Box sx={{width:"calc(100% - 206px)"}}><CustomSelectedOptions id={"RE"} selectedOptions={powerSupply.RE!==""?handleIDtoName([powerTagSupply.RETag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions></Box>:<></>}
                                            </Box>
                                        </>
                                    </Box>
                                </Box>
                                {/* <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>co2 Emission Factor <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                    <CustomTextField onChange={handleco2EmissionFactor} defaultValue={co2EmissionFactor} maxLength={16} width={224}/> 
                                </Box> */}
                                {/* <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Shiftwise</Typography>
                                    <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                        <>
                                            {/* <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Tag <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                                <CustomTextField  onChange={handleTODZone} disabled={true} defaultValue={'Energy'} maxLength={16} width={224}/> 
                                            </Box> *}
                                            <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Shift Name {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*}</Typography>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Shift Time {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*}</Typography>
                                                <Button  onClick={handleShiftAdd} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"center",marginTop:'-8px'}}><LK_Add color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
                                            </Box> 
                                            {shiftDetails.map((_value,index)=>(
                                            <>
                                                <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                    <CustomTextField id={index} onChange={handleShiftName} defaultValue={shiftDetails[index][0]} maxLength={16} width={224}/> 
                                                    <CustomTextField id={index} onChange={handleShiftTime} defaultValue={shiftDetails[index][1]} maxLength={16} width={224}/> 
                                                    <Button id={index} onClick={handleShiftDelete}  sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"center",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                                </Box> 
                                            </>
                                        ))}
                                        </>
                                    </Box>
                                </Box>
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>TOD</Typography>
                                    <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                        <>
                                            {/* <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Tag <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                                <CustomTextField  onChange={handleTODZone} disabled={true} defaultValue={'Energy'} maxLength={16} width={224}/> 
                                            </Box> *}
                                            <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Zone {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*}</Typography>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"300px"}}>Time of Day{/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*}</Typography>
                                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Unit Rate {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*}</Typography>
                                                <Button  onClick={handleTODAdd} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"center",marginTop:'-8px'}}><LK_Add color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
                                            </Box> 
                                            {TOD.map((_value,index)=>(
                                            <>
                                                <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                                    <CustomTextField id={index} onChange={handleTODZone} defaultValue={TOD[index][0]} maxLength={16} width={224}/> 
                                                    {/* <CustomTextField id={index} selected={handleTODTime} defaultValue={TOD[index][1]} maxLength={16} width={224}/>  *}
                                                    <Box sx={{flexDirection:'column',display:'flex',width:"300px"}}>
                                                        {TOD[index][1].map((_value,id)=>(
                                                            <>    
                                                                <Box sx={{flexDirection:'row',display:'flex',gap:"8px"}}>
                                                                <CustomTextField id={index.toString()+"."+id} onChange={handleTODTime} defaultValue={TOD[index][1][id]} maxLength={16} width={264}/> 
                                                                {id===0?
                                                                    <Button  id={index} onClick={handleTODTimeAdd} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"center",marginTop:'-8px'}}><LK_Add color='var(--LK_BrandBlue)' width={"20px"} height={"20px"}/></Button>
                                                                    :
                                                                    <Button id={index.toString()+"."+id} onClick={handleTODTimeDelete}  sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"start",marginTop:'0px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                                                }
                                                                </Box>
                                                            </>
                                                        ))}
                                                    </Box>
                                                    <CustomTextField id={index} onChange={handleTODUnitRate} defaultValue={TOD[index][2]} maxLength={16} width={224}/> 
                                                    <Button id={index} onClick={handleTODDelete}  sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"start",marginTop:'0px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                                </Box> 
                                            </>
                                        ))}
                                        </>
                                    </Box>
                                </Box> */}
                            </>
                            : 
                            <Box
                              sx={{
                                gap: "8px",
                                boxSizing: "border-box",
                                height: "calc(100%)",
                                width: "100%",
                                overflow: "auto",
                                alignContent: "center",
                              }}
                            >
                              <img
                                src={LK_Loading}
                                alt="loading..."
                                style={{ height: "15%", width: "auto", alignSelf: "center" }}
                              />
                            </Box>
                        }
                        {/* </Box> */}
                        {/* {
                                          <Dialog
                                              open={openTagDialog[0]}
                                              // onClose={handleCloseDialog}
                                              sx={{ "& .MuiDialog-paper": { backgroundColor:(theme == 'light')?"#FFFFFF":"#19191B",alignContent:"center",borderRadius:0,gap:'2px', width: '500px'} }}
                                          >
                                              <DialogTitle  sx={{marginTop:'16px',marginBottom:'8px', fontFamily:'Roboto',alignContent:"center",justifyContent:"left",textAlign:'left','&.MuiDialogTitle-root':{padding:'0px 16px'}}}>
                                                  {"Select Device and Tag"}
                                              </DialogTitle>
                                              <DialogContent sx={{alignContent:"center",marginBottom:'4px','&.MuiDialogContent-root':{padding:'0px 16px'}}} >
                                                <Box
                                                  sx={{
                                                    flex: 1, // ← takes all remaining height after the title
                                                    minHeight: 0, // ← CRITICAL: allows flex child to shrink below content size
                                                    overflowY: "auto", // ← scroll happens HERE, not on Tree
                                                    // overflowX: "hidden",
                                                    padding:'8px',
                                                    paddingRight:'0px',
                                                    backgroundColor:theme === "dark" ? "#000000" : "#EFEFEF",
                                                  }}
                                                >
                                                  <Tree
                                                    style={{backgroundColor:theme === "dark" ? "#000000" : "#EFEFEF",color:theme === "dark" ? "#FFFFFF" : "#5B5B5B"}}
                                                    switcherIcon={<LK_ArrowDown color='#008cd7' width={"12px"} height={"12px"}/>}
                                                    //onSelect={onSelect}
                                                    treeData={processTreeData(tagConfiguration,openTagDialog[1]==="Guzzlers"?"multiple":"single")}
                                                  />
                                                </Box>
                                                  
                                              </DialogContent>
                                              <DialogActions sx={{justifyContent:'left',padding:"16px"}}> 
                        
                                                {<CustomButton onClick={handleTagConfirmDialog}  id={openTagDialog[1]} buttonText={"Save"} width={100}></CustomButton>} 
                                                {<CustomCancelButton onClick={handleCloseTagDialog} buttonText={"Cancel"} width={100}></CustomCancelButton>} 
                                              </DialogActions>
                                          </Dialog>
                          } */}
                       {
                        <Dialog
                            open={openTagDialog[0]}
                            // onClose={handleCloseDialog}
                            sx={{ "& .MuiDialog-paper": { backgroundColor:(theme == 'light')?"#FFFFFF":"#19191B",alignContent:"center",borderRadius:0,gap:'2px', width: '900px',maxWidth:'1200px'} }}
                        >
                            <DialogTitle  sx={{marginTop:'16px',marginBottom:'8px', fontFamily:'Roboto',alignContent:"center",justifyContent:"left",textAlign:'left','&.MuiDialogTitle-root':{padding:'0px 16px'}}}>
                                {"Select Device and Tag"}
                            </DialogTitle>
                            <DialogContent sx={{alignContent:"center",marginBottom:'4px','&.MuiDialogContent-root':{padding:'0px 16px'}}} >
                                <Box
                                  sx={{
                                    width: "100%",
                                    minHeight: "400px",
                                    maxHeight: "650px",
                                    height: "650px",
                                    backgroundColor:
                                      theme === "dark" ? "#1e1e1e" : "#FFFFFF",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "12px",
                                    boxSizing: "border-box",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "40%",
                                      height: "100%",
                                      minHeight: "400px",
                                      backgroundColor:
                                        theme === "dark" ? "#000000" : "#EFEFEF",
                                      padding: "8px",
                                      boxSizing: "border-box",
                                    }}
                                  > 
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        height: "26px",
                                        marginBottom: "10px",
                                        borderBottom:
                                          theme === "dark"
                                            ? "1px solid #3c3c3c"
                                            : "1px solid #c1c1c1",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                          fontSize: "16px",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Tags
                                      </Typography>
                                      <Box sx={{ flexGrow: 1 }}> </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        flex: 1, // ← takes all remaining height after the title
                                        minHeight: 0, // ← CRITICAL: allows flex child to shrink below content size
                                        overflowY: "auto", // ← scroll happens HERE, not on Tree
                                        // overflowX: "hidden",
                                        height: "calc(100% - 36px)",
                                        backgroundColor:theme === "dark" ? "#000000" : "#EFEFEF",
                                        boxSizing: "border-box",
                                        //  '& .ant-tree-switcher-noop': { width: '0px' }
                                      }}
                                    >
                                      <Tree
                                        style={{
                                          backgroundColor:
                                            theme === "dark" ? "#000000" : "#EFEFEF",
                                          color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                        }}
                                        switcherIcon={(nodeProps) => {
                                          if (nodeProps.isLeaf) {
                                            return null; // No icon for leaf nodes 
                                          }
                                          return nodeProps.expanded ? <LK_ArrowDown color='#008cd7' width={"12px"} height={"12px"}/>:<LK_ArrowRight color='#008cd7' width={"12px"} height={"12px"}/>;
                                        }}
                                        // selectable={false}
                                        // onSelect={onSelect}
                                        treeData={(processTreeData(tagConfiguration,"single"))}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: "20%",
                                      height: "calc(100% - 32px)",
                                      padding: "8px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "16px",
                                      boxSizing: "border-box",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <CustomButton
                                        onClick={moveRight}
                                        buttonText={">"}
                                        disabled={
                                          currentSelectedTag.Aggregation === ''
                                        }
                                      />
                                      <CustomButton
                                        onClick={moveLeft}
                                        buttonText={"<"}
                                        disabled={selectedRightItems.length === 0}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        backgroundColor:
                                          theme === "dark" ? "#000000" : "#EFEFEF",
                                        padding: "16px",
                                        visibility: "visible",
                                        width: "100%",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("SUM"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "SUM"}
                                        onChange={(val) => handleAggregationOption("SUM", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"SUMMATION"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("DIFF"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "DIFF"}
                                        onChange={(val) => handleAggregationOption("DIFF", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"DIFFERENCE"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("AVG"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "AVG"}
                                        onChange={(val) => handleAggregationOption("AVG", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"AVERAGE"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("MIN"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "MIN"}
                                        onChange={(val) => handleAggregationOption("MIN", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"MINIMUM"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("MAX"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "MAX"}
                                        onChange={(val) => handleAggregationOption("MAX", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"MAXIMUM"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("SVAL"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "SVAL"}
                                        onChange={(val) => handleAggregationOption("SVAL", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"START VALUE"}
                                      />
                                      <br />
      
                                      <CustomCheckbox
                                        disabled={
                                          (currentSelectedTag.Tag === '' ||
                                            disabledAggOptions.includes("EVAL"))
                                        }
                                        checked={currentSelectedTag.Aggregation === "EVAL"}
                                        onChange={(val) => handleAggregationOption("EVAL", val)}
                                      />
                                      <span>&nbsp;</span>
                                      <span>&nbsp;</span>
                                      <CustomLabel
                                        fontWeight={300}
                                        fontSize={14}
                                        color={"var(--PrimaryText)"}
                                        labelText={"END VALUE"}
                                      />
                                      <br />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: "40%",
                                      height: "100%",
                                      minHeight: "400px",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                      boxSizing: "border-box",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        height: "100%",
                                        width: "100%",
                                        backgroundColor:
                                          theme === "dark" ? "#000000" : "#EFEFEF",
                                        padding: "8px",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          marginBottom: "10px",
                                          borderBottom:
                                            theme === "dark"
                                              ? "1px solid #3c3c3c"
                                              : "1px solid #c1c1c1",
                                              height: "26px",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            color:
                                              theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                          }}
                                        >
                                          Selected {/* ({rightList.length}) */}
                                        </Typography>
                                        <Box sx={{ flexGrow: 1 }}> </Box>
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "8px",
                                          marginTop: "8px",
                                          overflow: "auto",
                                          height: "calc(100% - 26px)",
                                        }}
                                      >
                                        {selectedTag.length === 0 ? (
                                          <Typography
                                            sx={{
                                              color:
                                                theme === "dark" ? "#888888" : "#999999",
                                              fontSize: "14px",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            No tags added yet
                                          </Typography>
                                        ) : (
                                          selectedTag.map((item, index) => (
                                            <Box
                                              key={index}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "4px",
                                              }}
                                            >
                                              <CustomCheckbox
                                                checked={selectedRightItems.includes(item)}
                                                onChange={(checked) => {
                                                  if (checked) {
                                                    // Add to selected items
                                                    setSelectedRightItems([
                                                      ...selectedRightItems,
                                                      item,
                                                    ]);
                                                  } else {
                                                    // Remove from selected items
                                                    setSelectedRightItems(
                                                      selectedRightItems.filter(
                                                        (i) => i !== item,
                                                      ),
                                                    );
                                                  }
                                                }}
                                              />
                                              <CustomLabel
                                                fontWeight={300}
                                                fontSize={14}
                                                color={"var(--PrimaryText)"}
                                                labelText={(handleIDtoName([item])) + "." + item.Aggregation}
                                              />
                                            </Box>
                                          ))
                                        )}
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions sx={{justifyContent:'left',padding:"16px"}}> 
      
                              {<CustomButton onClick={handleTagConfirmDialog}  id={openTagDialog[1]} buttonText={"Save"} /*disabled={currentSelectedTag.Tag!==''}*/  width={100}></CustomButton>} 
                              {<CustomCancelButton onClick={handleCloseTagDialog} /*disabled={currentSelectedTag.Tag!==''}*/ buttonText={"Cancel"} width={100}></CustomCancelButton>} 
                            </DialogActions>
                        </Dialog>
                      }                 
                </Box>
            </Box>
        </Box>
      );
}
